export default {
    lineRegisterCode: 'รหัสการใช้งานไลน์',
    code: 'รหัส',
    copy: 'คัดลอก',
    copied: 'คัดลอกแล้ว',
    create: 'สร้าง',
    cancel: 'ยกเลิก'
}
